import * as React from "react";
import {  IconButton } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import InputAdornment from "@mui/material/InputAdornment";
import OutlinedInput from "@mui/material/OutlinedInput";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import TuneOutlinedIcon from "@mui/icons-material/TuneOutlined";
import { useTheme } from "@mui/material/styles";
import NewSearchForm from "./NewSearchForm";

export default function SearchComponent() {
  const theme = useTheme();
  const [isOpen, setIsOpen] = React.useState(false);
  const openForm = () => {
    setIsOpen(!isOpen);
  };
  return (
    <FormControl
      sx={{ width: { xs: "100%", md: "80ch" }, alignSelf: "center", ml: 6 }}
      variant="standard"
    >
      <OutlinedInput
        size="small"
        id="search"
        placeholder="Search…"
        sx={{
          flexGrow: 1,
          borderRadius: "50px",
          backgroundColor:
            theme.palette.mode === "dark" ? theme.palette.primary.dark : "",
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor:
              theme.palette.mode === "dark"
                ? theme.palette.primary.dark
                : theme.palette.primary.main,
          },
          "&:hover > .MuiOutlinedInput-notchedOutline": {
            borderColor:
              theme.palette.mode === "dark"
                ? theme.palette.primary.dark
                : theme.palette.primary.main,
          },
        }}
        startAdornment={
          <InputAdornment position="start" sx={{ color: "text.primary" }}>
            <SearchRoundedIcon fontSize="small" />
          </InputAdornment>
        }
        endAdornment={
          <IconButton
            aria-label="tune"
            color="inherit"
            onClick={() => openForm()}
            sx={{ color: theme.palette.text.primary }}
          >
            <TuneOutlinedIcon />{" "}
          </IconButton>
        }
        inputProps={{
          "aria-label": "search",
        }}
      />
      {isOpen && (
        <NewSearchForm open={isOpen}/>
      )}
    </FormControl>
  );
}
